import { CurrencyInfo } from 'idt-ecommerce-api/stores/stores.models';


export class MoneyHelpers {

  /**
     * Devuelve el precio formateado con el tipo de moneda (ej. "29.99 €")
     *
     * @param {number} price el precio entero - tal y como nos viene de back
     * @param {StoreDetailLocale} currencyInfo le pasamos los valores del contexto que necesitamos para aplicar la mascara
     */
  public static formatPriceWithCurrencySymbol(price: number, currencyInfo: CurrencyInfo): string {
    const mask: string = price >= 0 ? currencyInfo.currencyFormatPos : currencyInfo.currencyFormatNeg;
    const maskWithoutCurrencyMatch: RegExpMatchArray | null = mask.match(/[#0][#0,.]*[#0]/);
    const maskWithoutCurrency: string = maskWithoutCurrencyMatch && maskWithoutCurrencyMatch.length > 0 ? maskWithoutCurrencyMatch[0] : '';
    const dotIndex: number = maskWithoutCurrency.indexOf('.');
    const maskIntegerPart: string = dotIndex === -1 ? maskWithoutCurrency : maskWithoutCurrency.substring(0, dotIndex);
    const maskDecimalPart: string = dotIndex === -1 ? '' : maskWithoutCurrency.substring(dotIndex + 1);
    const commaIndex: number = maskIntegerPart.lastIndexOf(',');
    const numberOfGrouping: number = commaIndex !== -1 ? maskIntegerPart.length - 1 - commaIndex : 0;
    const numberOfDecimals: number = Math.abs(currencyInfo.currencyDecimals);

    const priceStr: string = this.priceCentsValueStringWithAllZeros(price, numberOfDecimals); // '099'
    const integerPathLength: number = priceStr.length - numberOfDecimals;
    const integerPartValue: string = priceStr.substring(0, integerPathLength);
    const decimalPartValue: string = priceStr.substring(integerPathLength);

    const integerPart = this.integerPartWithGroupChar(integerPartValue, numberOfGrouping, currencyInfo.currencyGroupingChar); // '1.000.000'
    const decimalPart = this.decimalPartWithDecimalChar(decimalPartValue, maskDecimalPart, currencyInfo.currencyDecimalChar); // ',99'
    const resultWithoutCurrency: string = integerPart + decimalPart;
    const resultWithCurrency: string = mask.replace(/[#0][#0,.]*[#0]/, resultWithoutCurrency).trim();
    return resultWithCurrency;
  }

  /**
     * Devuelve el descuento con el porcentaje (ej: 30%)
     *
     * @param {number} price el precio con el descuento
     * @param {number} oldPrice el precio sin el descuento
     */
  public static getDiscountFromPrice(price: number, oldPrice: number): string {
    let discountStr = '';
    if (price > 0 && oldPrice > 0) {
      discountStr = `${Math.round((1 - price / oldPrice) * 100)}%`;
    }
    return discountStr;
  }

  /**
     * Devuelve el descuento con el porcentaje truncado (ej:30,9% --> 30%)
     *
     * @param {number} price el precio con el descuento
     * @param {number} oldPrice el precio sin el descuento
     */
  public static getTruncateDiscountFromPrice(price: number, oldPrice: number): string {
    let discountStr = '';
    if (price > 0 && oldPrice > 0) {
      discountStr = `${Math.floor((1 - price / oldPrice) * 100)}%`;
    }
    return discountStr;
  }

  // ---- Private functions ----

  private static priceCentsValueStringWithAllZeros(price: number, numberOfDecimals: number): string {
    let priceStr = Math.abs(price).toString();

    const maxDecimals = numberOfDecimals + 1 - priceStr.length;
    for (let i = 0; i < maxDecimals; i++) {
      priceStr = `0${priceStr}`;
    }
    return priceStr;
  }

  private static integerPartWithGroupChar(integerPart: string, numberOfGrouping: number, currencyGroupingChar: string) {
    let result = '';
    for (let i = 0; i < integerPart.length; i++) {
      if (i > 0 && numberOfGrouping > 0 && ((integerPart.length - i) % numberOfGrouping) === 0) {
        result += currencyGroupingChar;
      }
      result += integerPart[i];
    }
    return result;
  }

  private static decimalPartWithDecimalChar(decimalPart: string, maskDecimalPart: string, currencyDecimalChar: string): string {
    let result = '';
    const decimalTransform = Math.max(maskDecimalPart.replace(/#/g, '').length, Math.min(maskDecimalPart.length, decimalPart.length));
    for (let i = 0; i < decimalTransform; i++) {
      if (i === 0) {
        result += currencyDecimalChar;
      }
      result += decimalPart[i] ? decimalPart[i] : '0';
    }
    return result;
  }

}
